import { render, staticRenderFns } from "./StakingPoint.vue?vue&type=template&id=738c41f0"
import script from "@/scripts/stakingpoint/stakingpoint.js?vue&type=script&lang=js&external"
export * from "@/scripts/stakingpoint/stakingpoint.js?vue&type=script&lang=js&external"
import style0 from "./StakingPoint.vue?vue&type=style&index=0&id=738c41f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports